<form>
  <p class="field-dialog__content__scroll__title">
    {{ 'USERS.DIALOG.TAB_GROUPS.LINKED.TITLE' | translate }} ({{ filteredLinkedGroups.length || 0 }})
  </p>

  <div class="tab-groups__body">
    <p *ngIf="!filteredLinkedGroups.length" class="tab-groups__body__not-found-title">
      {{
        (searchInput.value ? 'USERS.DIALOG.TAB_GROUPS.LINK.NOT_FOUND' : 'USERS.DIALOG.TAB_GROUPS.LINKED.NOT_FOUND')
          | translate
      }}
    </p>

    <ng-container *ngIf="filteredLinkedGroups.length">
      <div
        class="card tab-groups__body__card"
        *ngFor="let linkedGroup of filteredLinkedGroups; index as groupIndex"
        [fxShow]="groupIndex + 1 >= firstPaginatedLinkedGroupIndex && groupIndex + 1 <= lastPaginatedLinkedGroupIndex"
        fxLayout="row"
        fxLayout="space-between center"
        fxLayoutGap="16px"
      >
        <div fxLayout="column" fxLayoutAlign="center start" fxFlex>
          <p class="tab-groups__body__card__name">
            {{ linkedGroup.name }}
            <span class="tab-groups__body__card__archived" *ngIf="linkedGroup.archived">
              {{ 'USERS.DIALOG.TAB_GROUPS.ARCHIVED' | translate }}
            </span>
          </p>
          <p class="tab-groups__body__card__description">
            {{ linkedGroup.description || 'USERS.DIALOG.TAB_GROUPS.NO_DESCRIPTION' | translate }}
          </p>
        </div>

        <div *ngIf="!isViewMode">
          <button
            (click)="unlinkGroup(linkedGroup, groupIndex)"
            class="tab-groups__body__card__remove"
            [ngClass]="{ 'tab-groups__body__card__remove--disabled': filteredLinkedGroups.length === 1 }"
            [matTooltip]="
              filteredLinkedGroups.length === 1
                ? ('USERS.DIALOG.TAB_GROUPS.LINKED.ONE_GROUP_REQUIRED' | translate)
                : ('USERS.DIALOG.TAB_GROUPS.LINKED.UNLINK' | translate)
            "
            matTooltipPosition="left"
            mat-icon-button
            [disabled]="filteredLinkedGroups.length === 1"
          >
            <i class="angularjs-fuse-icon icon-account-minus"></i>
          </button>
        </div>
      </div>

      <div class="tab-groups__body__paginate" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
        <p class="tab-groups__body__paginate__title">
          {{
            'USERS.DIALOG.TAB_GROUPS.LINKED.PAGINATE'
              | translate
                : {
                    total: filteredLinkedGroups.length,
                    firstPaginatedLinkedGroupIndex: firstPaginatedLinkedGroupIndex,
                    lastPaginatedLinkedGroupIndex:
                      lastPaginatedLinkedGroupIndex <= filteredLinkedGroups.length
                        ? lastPaginatedLinkedGroupIndex
                        : filteredLinkedGroups.length
                  }
          }}
        </p>

        <button
          mat-stroked-button
          (click)="changePage()"
          [disabled]="firstPaginatedLinkedGroupIndex <= 1"
          class="tab-groups__body__paginate__button"
        >
          {{ 'USERS.DIALOG.TAB_GROUPS.PREVIOUS' | translate }}
        </button>

        <button
          mat-stroked-button
          (click)="changePage(true)"
          [disabled]="lastPaginatedLinkedGroupIndex >= filteredLinkedGroups.length"
          class="tab-groups__body__paginate__button"
        >
          {{ 'USERS.DIALOG.TAB_GROUPS.NEXT' | translate }}
        </button>
      </div>
    </ng-container>
  </div>
</form>
